/* tslint:disable */
/* eslint-disable */
/**
 * Trust Investigator APP
 * The Law Society Trust Investigation Api with Swagger, Swashbuckle, and API Versioning.
 *
 * OpenAPI spec version: 2.0
 * Contact: hitesh.patel@lawsociety.com.au
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { BooleanResponse } from '../models';
import { ILPDirectorRequest } from '../models';
import { IlpDirectorIEnumerableResponse } from '../models';
import { IndividualFirmIEnumerableResponse } from '../models';
import { IndividualIEnumerableResponse } from '../models';
import { InvestigationSignatoryFilterRequest } from '../models';
import { LawIdUserLsApiIEnumerableResponse } from '../models';
import { PeopleStatsResponse } from '../models';
import { SearchLawIdUsersRequest } from '../models';
import { SignatoryFilterRequest } from '../models';
import { SignatoryIEnumerableResponse } from '../models';
import { SignatoryRequest } from '../models';
/**
 * PeopleApi - axios parameter creator
 * @export
 */
export const PeopleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns IlpDirectors
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet: async (practiceId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetILPDirectorsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet: async (practiceId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetIndividualsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns IlpDirectors
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet: async (practiceId: number, investigationId: number, keyword?: string, showActiveOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet.');
            }
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/People/GetInvestigationILPDirectorsByPracticeId/{practiceId}/{investigationId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)))
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (keyword !== undefined) {
                localVarQueryParameter['keyword'] = keyword;
            }

            if (showActiveOnly !== undefined) {
                localVarQueryParameter['showActiveOnly'] = showActiveOnly;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Signatories
         * @param {InvestigationSignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetInvestigationSignatoriesPost: async (body?: InvestigationSignatoryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/GetInvestigationSignatories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns PeopleStats
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetPeopleStatsByPracticeId/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TrustContacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPracticeTrustContactsPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetPracticeTrustContactsPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetPracticeTrustContacts/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns TrustCoordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet: async (practiceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet.');
            }
            const localVarPath = `/api/v2/People/GetPracticeTrustCoordinators/{practiceId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet: async (practiceId: number, investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet.');
            }
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/People/GetPrincipalsByPracticeId/{practiceId}/{investigationId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)))
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet: async (practiceId: number, investigationId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'practiceId' is not null or undefined
            if (practiceId === null || practiceId === undefined) {
                throw new RequiredError('practiceId','Required parameter practiceId was null or undefined when calling apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet.');
            }
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet.');
            }
            const localVarPath = `/api/v2/People/GetPrincipalsByPracticeStatus/{practiceId}/{investigationId}`
                .replace(`{${"practiceId"}}`, encodeURIComponent(String(practiceId)))
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns LawIdUserLsApi
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSearchLawIdUsersPost: async (body?: SearchLawIdUsersRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/GetSearchLawIdUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns Signatories
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoriesPost: async (body?: SignatoryFilterRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/People/GetSignatories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {ILPDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveIlpDirectorInvestigationIdPost: async (investigationId: number, body?: ILPDirectorRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2PeopleSaveIlpDirectorInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/People/SaveIlpDirector/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveSignatoryInvestigationIdPost: async (investigationId: number, body?: SignatoryRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investigationId' is not null or undefined
            if (investigationId === null || investigationId === undefined) {
                throw new RequiredError('investigationId','Required parameter investigationId was null or undefined when calling apiV2PeopleSaveSignatoryInvestigationIdPost.');
            }
            const localVarPath = `/api/v2/People/SaveSignatory/{investigationId}`
                .replace(`{${"investigationId"}}`, encodeURIComponent(String(investigationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PeopleApi - functional programming interface
 * @export
 */
export const PeopleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns IlpDirectors
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IlpDirectorIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns IlpDirectors
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, keyword?: string, showActiveOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IlpDirectorIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, keyword, showActiveOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Signatories
         * @param {InvestigationSignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetInvestigationSignatoriesPost(body?: InvestigationSignatoryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetInvestigationSignatoriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns PeopleStats
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PeopleStatsResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TrustContacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetPracticeTrustContactsPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetPracticeTrustContactsPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns TrustCoordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet(practiceId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualFirmIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet(practiceId, investigationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns LawIdUserLsApi
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LawIdUserLsApiIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetSearchLawIdUsersPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns Signatories
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignatoryIEnumerableResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleGetSignatoriesPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {ILPDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleSaveIlpDirectorInvestigationIdPost(investigationId: number, body?: ILPDirectorRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleSaveIlpDirectorInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2PeopleSaveSignatoryInvestigationIdPost(investigationId: number, body?: SignatoryRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponse>> {
            const localVarAxiosArgs = await PeopleApiAxiosParamCreator(configuration).apiV2PeopleSaveSignatoryInvestigationIdPost(investigationId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PeopleApi - factory interface
 * @export
 */
export const PeopleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Returns IlpDirectors
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<IlpDirectorIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<IndividualFirmIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns IlpDirectors
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {string} [keyword] 
         * @param {boolean} [showActiveOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, keyword?: string, showActiveOnly?: boolean, options?: any): AxiosPromise<IlpDirectorIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, keyword, showActiveOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Signatories
         * @param {InvestigationSignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetInvestigationSignatoriesPost(body?: InvestigationSignatoryFilterRequest, options?: any): AxiosPromise<SignatoryIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetInvestigationSignatoriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns PeopleStats
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any): AxiosPromise<PeopleStatsResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TrustContacts
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPracticeTrustContactsPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetPracticeTrustContactsPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns TrustCoordinators
         * @param {number} practiceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any): AxiosPromise<IndividualIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet(practiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any): AxiosPromise<IndividualFirmIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns IndividualFirms
         * @param {number} practiceId 
         * @param {number} investigationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any): AxiosPromise<IndividualFirmIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet(practiceId, investigationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns LawIdUserLsApi
         * @param {SearchLawIdUsersRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any): AxiosPromise<LawIdUserLsApiIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetSearchLawIdUsersPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns Signatories
         * @param {SignatoryFilterRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any): AxiosPromise<SignatoryIEnumerableResponse> {
            return PeopleApiFp(configuration).apiV2PeopleGetSignatoriesPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {ILPDirectorRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveIlpDirectorInvestigationIdPost(investigationId: number, body?: ILPDirectorRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV2PeopleSaveIlpDirectorInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns boolean
         * @param {number} investigationId 
         * @param {SignatoryRequest} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2PeopleSaveSignatoryInvestigationIdPost(investigationId: number, body?: SignatoryRequest, options?: any): AxiosPromise<BooleanResponse> {
            return PeopleApiFp(configuration).apiV2PeopleSaveSignatoryInvestigationIdPost(investigationId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PeopleApi - object-oriented interface
 * @export
 * @class PeopleApi
 * @extends {BaseAPI}
 */
export class PeopleApi extends BaseAPI {
    /**
     * 
     * @summary Returns IlpDirectors
     * @param {number} practiceId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetILPDirectorsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns IndividualFirms
     * @param {number} practiceId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetIndividualsByPracticeIdPracticeIdGet(practiceId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns IlpDirectors
     * @param {number} practiceId 
     * @param {number} investigationId 
     * @param {string} [keyword] 
     * @param {boolean} [showActiveOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, keyword?: string, showActiveOnly?: boolean, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetInvestigationILPDirectorsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, keyword, showActiveOnly, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Signatories
     * @param {InvestigationSignatoryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetInvestigationSignatoriesPost(body?: InvestigationSignatoryFilterRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetInvestigationSignatoriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns PeopleStats
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetPeopleStatsByPracticeIdPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TrustContacts
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetPracticeTrustContactsPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetPracticeTrustContactsPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns TrustCoordinators
     * @param {number} practiceId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet(practiceId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetPracticeTrustCoordinatorsPracticeIdGet(practiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns IndividualFirms
     * @param {number} practiceId 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetPrincipalsByPracticeIdPracticeIdInvestigationIdGet(practiceId, investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns IndividualFirms
     * @param {number} practiceId 
     * @param {number} investigationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet(practiceId: number, investigationId: number, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetPrincipalsByPracticeStatusPracticeIdInvestigationIdGet(practiceId, investigationId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns LawIdUserLsApi
     * @param {SearchLawIdUsersRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetSearchLawIdUsersPost(body?: SearchLawIdUsersRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetSearchLawIdUsersPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns Signatories
     * @param {SignatoryFilterRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleGetSignatoriesPost(body?: SignatoryFilterRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleGetSignatoriesPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {number} investigationId 
     * @param {ILPDirectorRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleSaveIlpDirectorInvestigationIdPost(investigationId: number, body?: ILPDirectorRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleSaveIlpDirectorInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Returns boolean
     * @param {number} investigationId 
     * @param {SignatoryRequest} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PeopleApi
     */
    public apiV2PeopleSaveSignatoryInvestigationIdPost(investigationId: number, body?: SignatoryRequest, options?: any) {
        return PeopleApiFp(this.configuration).apiV2PeopleSaveSignatoryInvestigationIdPost(investigationId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
